import { type AddedItem } from '@athena-lib/AddedToCartView/AddedToCartView.svelte';
import { getCartEventsTracker } from '$lib/gtmEventHelper.svelte';

type CheckoutDrawerContextValue =
  | null
  | { type: 'ItemAdded'; addedItem: AddedItem; progressBarState: 'paused' | 'started' | 'initial' }
  | { type: 'LocationPicker' }
  | { type: 'MiniCart' }
  | { type: 'Login'; triggerElement?: HTMLElement; noRedirectToCustomer?: boolean }
  | { type: 'DeliveryDetails'; triggerElement?: HTMLElement };

export type CheckoutDrawerContext = { value: CheckoutDrawerContextValue };

const cartEventsTracker = getCartEventsTracker('cart_drawer');

export const checkoutDrawerContext = $state<CheckoutDrawerContext>({
  value: null,
});
export const checkoutDrawerActions = {
  close: () => {
    if (checkoutDrawerContext.value?.type == 'Login') {
      checkoutDrawerContext.value.triggerElement?.focus();
    }

    checkoutDrawerContext.value = null;
  },
  openMiniCart: () => {
    checkoutDrawerContext.value = { type: 'MiniCart' };
  },
  addItemToCart: (addedItem: AddedItem): void => {
    checkoutDrawerContext.value = { type: 'ItemAdded', addedItem, progressBarState: 'initial' };
    cartEventsTracker.viewMiniCart();
  },
  openLocationPicker: (): void => {
    checkoutDrawerContext.value = { type: 'LocationPicker' };
  },
  openLogin: (element?: HTMLElement, noRedirectToCustomer?: boolean) => {
    checkoutDrawerContext.value = { type: 'Login', triggerElement: element, noRedirectToCustomer };
  },
  openDeliveryDetails: (element?: HTMLElement) => {
    checkoutDrawerContext.value = { type: 'DeliveryDetails', triggerElement: element };
  },
};
